exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comming-soon[data-v-4bc3a7d0]{display:none}.tabs.is-boxed li a[data-v-4bc3a7d0]:hover{color:hsla(0,0%,100%,.6);background-color:transparent}.tabs.is-boxed li.is-active a[data-v-4bc3a7d0]{background-color:#fff;cursor:pointer}.tabs.is-boxed li[data-v-4bc3a7d0]{cursor:pointer}.tabs.is-boxed li a[data-v-4bc3a7d0]{opacity:1;cursor:pointer}.tabs.is-boxed li.is-active a span[data-v-4bc3a7d0]{color:#2e323a}", ""]);

// exports
